import axios from "@/libs/api.request";

export const uploadbase64 = (data) => {
  return axios.request({
    url: "upload/uploadbase64",
    data: data,
    csrf: false,
    method: "post",
  });
};
